import { type ReactNode } from 'react';
import { Flame } from 'lucide-react';

export function HeroCountdown({ label }: { label: string }): ReactNode {
  return (
    <div className="flex flex-col items-center gap-1.5 text-center">
      <div className="flex items-center gap-1.5">
        <Flame size={14} strokeWidth={2.25} className="text-brand-coral" />
        <p className="text-xs font-semibold uppercase tracking-[0.14em] text-brand-coral">
          Tiempo restante
        </p>
      </div>
      <p className="font-display text-4xl font-bold leading-none tabular-nums text-brand-red sm:text-5xl">
        {label}
      </p>
    </div>
  );
}

type BarProps = { count: number; threshold: number };

export function ProgressCounter({ count, threshold }: BarProps): ReactNode {
  const pct = Math.min((count / threshold) * 100, 100);
  return (
    <div className="space-y-1.5">
      <div className="flex items-baseline justify-between gap-sm">
        <span className="text-xs tabular-nums text-brand-coral/85">
          <span className="font-semibold text-text-primary">{count}</span>
          {' / '}
          {threshold} creadores
        </span>
        <span className="text-xs font-semibold tabular-nums text-text-primary">
          {Math.round(pct)}%
        </span>
      </div>
      <div className="h-3 overflow-hidden rounded-full bg-brand-red/20">
        <div
          className="h-full rounded-full bg-brand-red shadow-[0_0_12px_rgba(255,68,68,0.5)] transition-all"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}

export function HowToHint(): ReactNode {
  return (
    <p className="text-center text-xs leading-relaxed text-text-tertiary">
      Sigue añadiendo creadores como siempre, desde Instagram. Cada creador
      válido que añadas cuenta para llegar a 99.
    </p>
  );
}

export function EvaluatingNotice(): ReactNode {
  return (
    <p className="text-center text-xs text-text-tertiary">
      Evaluando resultado...
    </p>
  );
}
